/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Member_Transfer_SuccessInputs */



/**
* | output |
* | --- |
* | "Ownership transferred: {count} shared spaces and projects now have a new administrator." |
*
* @param {Member_Transfer_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_transfer_success = /** @type {((inputs: Member_Transfer_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Transfer_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Besitz übertragen: ${i?.count} geteilte Spaces und Projekte haben nun einen neuen Administrator.`)
	return /** @type {LocalizedString} */ (`Ownership transferred: ${i?.count} shared spaces and projects now have a new administrator.`)
});